import { render } from "./AvatarBuilder.vue?vue&type=template&id=6a916e39"
import script from "./AvatarBuilder.vue?vue&type=script&lang=js"
export * from "./AvatarBuilder.vue?vue&type=script&lang=js"

import "./AvatarBuilder.vue?vue&type=style&index=0&id=6a916e39&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__